import React, { useState } from 'react';

import { Anchor, Drawer, Button } from 'antd';
import image1 from '../../assets/images/logo_size.jpg';
const { Link } = Anchor;

function AppHeader() {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <div className="container-fluid">
      <div className="header">
        <div className="logo">
        <img  alt="ITCATER" style={{width: "15%",height: "15%"}} class="logoimg" src={image1} />
          <a href="#hero"> ITCater </a>
          <a href="#hero" class="logosub" > Innovate, Connect, Inspire</a>
        </div>
        <div className="mobileHidden">
          <Anchor targetOffset="65">
            <Link href="#hero" title="Home" />
            <Link href="#about" title="About" />
            <Link href="#services" title="services" />
            <Link href="#feature" title="Features" />
            <Link href="#works" title="How it works" />
            {/* <Link href="#faq" title="FAQ" /> */}
            <Link href="#pricing" title="Careers" />
            <Link href="#contact" title="Contact" />
            
          </Anchor>
        </div>
        <div className="mobileVisible">
          <Button type="primary" onClick={showDrawer}>
            <i className="fas fa-bars"></i>
          </Button>
          <Drawer
            placement="right"
            closable={false}
            onClose={onClose}
            visible={visible}
          >
            <Anchor targetOffset="65">
              <Link href="#hero" title="Home" />
              <Link href="#about" title="About" />
              <Link href="#feature" title="Features" />
              <Link href="#works" title="How it works" />
              <Link href="#pricing" title="Careers" />
              <Link href="#contact" title="Contact" />
            </Anchor>
          </Drawer>
        </div>
      </div>
    </div>
  );
}

export default AppHeader;